var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 32C64 49.673 49.673 64 32 64C14.327 64 0 49.673 0 32C0 14.327 14.327 0 32 0C49.673 0 64 14.327 64 32Z",
    fill: "#092D3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1538 42.1114L35.572 10.6548C34.5896 9.09828 33.2949 8.32031 32.0002 8.32031C30.7048 8.32031 29.4107 9.09828 28.4283 10.6548L9.84659 42.1114C7.88115 45.2251 9.29491 48.0003 12.9851 48.0003H51.0146C54.7048 48.0003 56.1186 45.2251 54.1538 42.1114Z",
    fill: "#FBD75A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0142 34.3261C32.973 34.8455 32.485 35.2363 31.9255 35.1974C31.4166 35.1623 31.0226 34.7853 30.9868 34.3261L30.0853 23.0341C30.0076 22.0529 30.801 21.1978 31.8586 21.1251C32.9162 21.0523 33.8373 21.7894 33.915 22.7706C33.9224 22.8565 33.9211 22.9512 33.915 23.0341L33.0142 34.3261ZM30.0801 40.3201C30.0801 39.2596 30.9396 38.4001 32.0001 38.4001C33.0606 38.4001 33.9201 39.2596 33.9201 40.3201C33.9201 41.38 33.0606 42.2401 32.0001 42.2401C30.9396 42.2401 30.0801 41.38 30.0801 40.3201Z",
    fill: "#092D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFilled);
export default __webpack_public_path__ + "static/media/alert-filled.cf9fa60e593e5a62b47a0b7a9c5160ee.svg";
export { ForwardRef as ReactComponent };